<template>
    <div id="sc-message-list" ref="scrollList" :style="{ backgroundColor: 'transparent' }" class="sc-message-list">
        <!-- Form mesajdan once gonderildiyse kart en ustte kalir -->
        <div v-if="showInline && inlineAtStart" class="sc-inline-anchor">
            <slot name="inline" :index="-1"></slot>
        </div>
        <template v-for="(message, idx) in filteredMessages">
            <Message
                :key="message.raw.uniqMessageId"
                :id="'sc-message_' + message.raw.uniqMessageId"
                :colors="colors"
                :message="message"
                :lastMessage="$_.last(messages.filter((x) => x.author === 'chatbot'))"
                :messageStyling="messageStyling"
                :participants="participants"
                :user="profile(message.author)"
                @remove="$emit('remove', message)"
                :conversation-terminated="conversationTerminated"
                v-if="isVisibleMessage(message)"
            >
                <template v-slot:user-avatar="scopedProps">
                    <slot :message="scopedProps.message" :user="scopedProps.user" name="user-avatar"></slot>
                </template>
                <template v-slot:text-message-body="scopedProps">
                    <slot
                        :me="scopedProps.me"
                        :message="scopedProps.message"
                        :messageColors="scopedProps.messageColors"
                        :messageText="scopedProps.messageText"
                        name="text-message-body"
                    >
                    </slot>
                </template>
                <template v-slot:text-message-toolbox="scopedProps">
                    <slot :me="scopedProps.me" :message="scopedProps.message" name="text-message-toolbox"></slot>
                </template>
            </Message>

            <!-- Karsilama karti akisin icinde sabit duruyor: sonraki mesajlar
                 altina iniyor, kart hep en altta kalmiyor. -->
            <div
                v-if="idx === inlineIndex"
                :key="'inline-anchor'"
                class="sc-inline-anchor"
            >
                <slot name="inline" :index="idx"></slot>
            </div>
        </template>

        <!-- Hic mesaj yokken cipa kurulamiyor: kart listenin sonunda. -->
        <div v-if="showInline && !inlineAtStart && inlineIndex === -1" class="sc-inline-anchor">
            <slot name="inline" :index="-1"></slot>
        </div>

        <Message
            v-show="showTypingIndicator !== ''"
            :colors="colors"
            :message="{ author: showTypingIndicator, type: 'typing' }"
            :messageStyling="messageStyling"
            :user="{}"
        />
        <!-- gosterge mutlak konumlu; yer ayrilmazsa son balonun ustune biniyordu -->
        <div v-if="showTypingIndicator !== ''" class="sc-typing-spacer"></div>
        <slot name="rate" />
    </div>
</template>

<script>
import Message from "./Message.vue";
import chatIcon from "./assets/chat-icon.svg";
import { log2 } from "../../../utils/log2";
import EllipsIconButton from "../../../common/IconButton.vue";
import _ from "lodash";
import { autoScrollDisabled } from "../../../utils/autoScrollGuard";

const log = log2("MessageList");
export default {
    components: {
        Message,
        EllipsIconButton,
    },
    props: {
        // Akis ici kart gosterilsin mi? Cipa bu bilesenin kendi icinde
        // donduruluyor: iki bilesen arasindaki zamanlama sorun cikariyordu.
        showInline: {
            type: Boolean,
            default: false,
        },
        // Form ziyaretci mesajindan once gonderildi (form acilista): kart ilk mesajin ustunde durur
        inlineAtStart: {
            type: Boolean,
            default: false,
        },
        onSubmit: {
            type: Function,
            required: false,
            default: () => {},
        },
        participants: {
            type: Array,
            default: () => [],
        },
        messages: {
            type: Array,
            required: true,
        },
        showTypingIndicator: {
            type: String,
            required: true,
        },
        colors: {
            type: Object,
            required: true,
        },
        alwaysScrollToBottom: {
            type: Boolean,
            required: true,
        },
        messageStyling: {
            type: Boolean,
            required: true,
        },
        scrollVS: {
            required: false,
        },
        conversationTerminated: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            existNewMessage: false,
        };
    },
    methods: {
        _scrollDown() {
            // log("_scrollDown", this.scrollVS);
            //this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight;
            if (this.scrollVS) {
                this.scrollVS.scrollTo({
                    x: 0,
                    y: "100%",
                });
                return;
            }
            // vuescroll kaldirildi: gercek kaydirma kabi #messageContent.
            // Kosulsuz dibe cekmek kullanicinin elle kaydirmasini engelliyordu:
            // uzun formda yukari cikip alan duzeltmek mumkun olmuyordu.
            const kap = document.getElementById("messageContent");
            if (!kap) return;
            // Karsilama formu ekrandayken kaydirma yok.
            if (autoScrollDisabled()) return;
            const dipteMi = kap.scrollHeight - kap.scrollTop - kap.clientHeight <= 150;
            if (dipteMi) kap.scrollTop = kap.scrollHeight;
        },
        profile(author) {
            const profile = this.participants.find((profile) => profile.id === author);

            // A profile may not be found for system messages or messages by 'me'
            return profile || { imageUrl: "", name: author === "chatbot" ? "Müşteri Temsilcisi" : "" };
        },
        isVisibleMessage(message) {
            console.log("isVisibleMessage", message);
            const hiddenTypes = ["custom", "function_call", "rag_query"];
            return hiddenTypes.indexOf(_.get(message, "raw.systemMessageType")) === -1;
        },
    },
    computed: {
        // Kart, ziyaretcinin ILK mesajinin hemen ardina ciziliyor. Donmus
        // indeks denendi ve tutmadi: sunucu mesajlari kendi zaman damgasina
        // gore yeniden siraliyor ve id'leri degistiriyor, indeks anlamini
        // yitiriyordu. Bu kural sıralamadan ve id'den bagimsiz.
        inlineIndex() {
            if (!this.showInline || this.inlineAtStart) return -1;
            const list = this.filteredMessages || [];
            return list.findIndex((m) => m && m.author === "me");
        },

        defaultChatIcon() {
            return chatIcon;
        },
        filteredMessages() {
            return this.messages.filter(
                msg =>
                    _.get(msg, 'raw.messageType') !== 'chatbot-private' &&
                    _.get(msg, 'raw.messageType') !== 'chatbot-debug' &&
                    _.get(msg, 'raw.messageType') !== 'private' &&
                    // Web analytics urun ilgisi / siparis kartlari yalnizca panel icindir
                    _.get(msg, 'raw.messageType') !== 'product-view' &&
                    _.get(msg, 'raw.messageType') !== 'order' &&
                    // Musteri kullanicisinin ajan oturumu karti (yalnizca HQ paneli; sunucu zaten filtreler)
                    _.get(msg, 'raw.messageType') !== 'suphi-session'
            );
        }
    },
    mounted() {
        log("mounted");
        this.$emit("mounted");
        this.$nextTick(() => this._scrollDown());
    },
    // updated() kancasinda dibe cekme yok: ChatWindow'un her yeniden cizimi
    // (ornegin "asagi in" butonunun belirmesi) bu bileseni de guncelliyor ve
    // az mesajda kullanicinin yukari kaydirmasini aninda geri aliyordu.
    // Yeni mesaj ve boy degisimi kaydirmasi ChatWindow'da (watcher + ResizeObserver).
};
</script>

<style scoped lang="scss">
.sc-typing-spacer {
    height: 40px;
}

// Gonderilmis kartin hemen altina dusen ilk balon karta yapisiyordu.
.sc-inline-anchor {
    padding-bottom: 14px;
}

.sc-message-list {
    background-size: 100%;
    padding: 10px var(--sps-gutter, 12px);
    position: relative;
    // Alt bosluk .messages-content'in padding-bottom'undan geliyor; buradaki
    // 22px ustune biniyor ve karsilama butonlarini balondan uzaga itiyordu.
    margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/MessageList.vue